<template>
    <split-pane  :min-percent='12' :default-percent='15' split="vertical" style="background:white; height:100%">
        <template slot="paneL">
              <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"></el-input>
                <el-tree :data="orgData" 
                            :props="defaultProps" 
                            @node-click="handleNodeClick" 
                            default-expand-all
                            node-key="id"                       
                            :style="{height: scrollerHeight,overflow:'auto', 'margin-top':'3px'}"
                            highlight-current
                            ref="eltree"
                            v-loading="loading"
                            :filter-node-method="filterNode"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(255, 251, 255, 0.8)"
                            :expand-on-click-node="false">
                    <template v-slot="{node,data}">                                     
                        <span v-if="data.id ==0 "  class="nodeRoot" >
                          
                          <span   style="font-size:14px; color:#409efe"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:18px;margin-right:4px;"></i>{{ node.label}} </span>
                        </span>                  
                        <span v-else > 
                            <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#E6A23C;font-size:10px;margin-right:4px;"></i>{{ node.label}} </span>
                        </span>
                    </template>
                </el-tree>    
        </template>
        <template slot="paneR">
            <div style="background:#fff;overflow-y:auto;height:92vh  "> 
                <div style="width:100%; border-bottom:2px solid #389;padding-top:3px;display:flex;line-height:30px;height:38px">
                    <div style=" width:240px" >
                        <i class="iconfont icon-xitongguanli" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool" @click="typeSet" :underline="false" ><span style="font-size:12px;margin-right:15px;">产品类别设置</span></el-link>
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">新增类别属性</span></el-link>
                    </div>
                    <div style=" width:560px" >
                        <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                            <span v-for="item in tabCol" :key='item.key'>
                                <el-option :label="item.title" :value="item.key"></el-option>
                            </span>
                        </el-select> 
                        <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam" size="small" style="width:320px;height:30px ">
                            <el-select v-model="oper" slot="prepend" size="small" style="width:110px; ">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                                    </span>
                            </el-select>
                            <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                        </el-input>  
                    </div> 
                </div>
                <el-table :data="tmpData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    :row-key="getRowKey"
                    @row-click="dtlClick"
                    style="overflow:auto;margin-top:3px;"
                    size="small"
                    ref="proptab"
                    height="260px" 
                    highlight-current-row>
                    <span  v-for="(item ,index) in tabCol" :key="index">   
                        <el-table-column   v-if="item.thide==='N' &&item.key!=='ISHAND'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column  v-if=" item.key==='ISHAND'"
                            prop="STFG"
                            label="手动输入"
                            align="center"                                  
                            sortable
                            width="100">
                            <template slot-scope="scope" >
                                <el-checkbox disabled false-label="" true-label="Y" v-model="scope.row.ISHAND" >&nbsp;</el-checkbox>
                            </template>
                        </el-table-column> 
                    </span> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope"> 
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="editBool" @click="editRec(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="delBool" @click="delRec(scope.row )" :underline="false"  ><span style="font-size:11px; ">删除 </span></el-link>
                        </template>
                    </el-table-column>                       
                </el-table>
                <div class="one-div"> 
                    <div class="oneRow">
                        <i class="iconfont icon-xinzeng" style="color:#1090FF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool" @click="dtlAdd" :underline="false" ><span style="font-size:12px;margin-right:15px;border-bottom:1px solid red">新增属性规格</span></el-link>
                    </div>
                </div>
                <el-table :data="dtlData" 
                    border                            
                    disabled-hover
                    :row-key="getRowKey2"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    style="overflow:auto;margin-top:-9px;"
                    size="small"
                    ref="dtltab"
                    :height="260" 
                    highlight-current-row>
                    <span  v-for="(item ,index) in dtlCol" :key="index">   
                        <el-table-column   v-if="item.thide==='N'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope"> 
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="editBool" @click="dtlEdit(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="delBool" @click="dtlDel(scope.row )" :underline="false"  ><span style="font-size:11px; ">删除 </span></el-link>
                        </template>
                    </el-table-column>                       
                </el-table>
                <div v-if="treeid!=='0'" > 
                    <div class="one-div" style="margin-top:2px;height:30px"> 
                        <div class="oneRow">
                            <span style="font-size:12px;margin-right:15px;">基准国内售价【人民币】成本公式设置</span> 
                            <el-button :disabled="treeid==0" @click="calcSave" type="plain" size="mini" icon="el-icon-s-tools"> 保存公式</el-button>
                        
                        </div>
                    </div>
                    <div style="line-height:30px;height:175px;  border:1px solid #ccc; overflow:auto;font-size:12px;font-weight:bold;color:#389">
                        <div style="display:flex;flex-wrap:nowrap;">
                            <div style="text-align:center;min-width:90px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc;white-wrap:nowrap">Bom成本*(100+ </div>
                            <div style="text-align:center;min-width:80px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc;white-wrap:nowrap">净利润)/100 </div>
                            <div style="text-align:center;min-width:55px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc"> * ( 100 +  </div>
                            <div style="text-align:center;width:450px;border-right:1px solid #ccc;height:65px"> 
                                <div style="text-align:center;line-height:30px;width:100%;border-bottom:1px solid #ccc">制造费用</div>
                                <div style="display:flex;border-bottom:1px solid #ccc;line-height:33px">
                                    <div style="text-align:center;width:15px"> ( </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">人工% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">社保% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">福利% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">水电摊分% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">租金摊分% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">损耗率% </div>
                                    <div style="text-align:center;width:15px"> ) </div>
                                </div>
                            </div>
                            <div style="text-align:center;min-width:20px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc"> + </div>
                            <div style="text-align:center;width:520px;border-right:1px solid #ccc;height:65px"> 
                                <div style="text-align:center;line-height:30px;width:100%;border-bottom:1px solid #ccc">销售费用</div>
                                <div style="display:flex;border-bottom:1px solid #ccc;line-height:33px">
                                    <div style="text-align:center;width:15px"> ( </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">人工% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">社保% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">福利% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">办公费用% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">运输费% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">提成% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">广告%</div> 
                                    <div style="text-align:center;width:15px"> ) </div>
                                </div>
                            </div>
                            <div style="text-align:center;min-width:20px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc"> + </div>
                            <div style="text-align:center;width:450px;border-right:1px solid #ccc;height:65px"> 
                                <div style="text-align:center;line-height:30px;width:100%;border-bottom:1px solid #ccc">研发费用</div>
                                <div style="display:flex;border-bottom:1px solid #ccc;line-height:33px">
                                    <div style="text-align:center;width:15px"> ( </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">人工% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">社保% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">福利% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">办公费用% </div>
                                
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">提成% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">开发费用%</div> 
                                    <div style="text-align:center;width:15px"> ) </div>
                                </div>
                            </div>

                            <div style="text-align:center;min-width:20px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc"> + </div>
                            <div style="text-align:center;width:310px;border-right:1px solid #ccc;height:65px"> 
                                <div style="text-align:center;line-height:30px;width:100%;border-bottom:1px solid #ccc">管理费用</div>
                                <div style="display:flex;border-bottom:1px solid #ccc;line-height:33px">
                                    <div style="text-align:center;width:15px"> ( </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">人工% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">社保% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">福利% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">管理费用% </div>
                        
                                    <div style="text-align:center;width:15px"> ) </div>
                                </div>
                            </div>

                            <div style="text-align:center;min-width:20px;line-height:60px;border-right:1px solid #ccc;height:65px;border-bottom:1px solid #ccc"> + </div>
                            <div style="text-align:center;width:540px;border-right:1px solid #ccc;height:65px"> 
                                <div style="text-align:center;line-height:30px;width:100%;border-bottom:1px solid #ccc">财务费用</div>
                                <div style="display:flex;border-bottom:1px solid #ccc;line-height:33px">
                                    <div style="text-align:center;width:15px"> ( </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">人工% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">社保% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">福利% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">利息% </div>
                                
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">手续费% </div>
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">税费%</div> 
                                    <div style="text-align:center;width:70px;border-right:1px solid #ccc">汇兑%</div> 
                                    <div style="text-align:center;width:35px"> ))/100 </div>
                                </div>
                            </div>
                        </div>

                        <div style="display:flex;flex-wrap:nowrap;">
                            <div style="text-align:center;min-width:90px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc"></div>
                            <div style="text-align:center;min-width:80px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['NET_PCT']"  @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:55px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">  </div>
                            <!-- 制造费用 -->
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_EMP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> 
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_BAO']"  @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_FULI']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_WATER']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_RENT']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MAKE_WASTE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>

                            <div style="text-align:center;min-width:20px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">  </div>
                            <!-- 销售费用 -->
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_EMP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> 
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_BAO']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_FULI']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_FEE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_SHIP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_FUND']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['SALE_ADVER']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>                        
                            <div style="text-align:center;min-width:20px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">  </div>
                            
                            <!-- 研发费用 -->
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_EMP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> 
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_BAO']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_FULI']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_OFFICE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_FUND']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_DEVFEE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:20px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc"> </div>
                            
                            <!-- 管理费用 -->
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MGR_EMP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> 
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MGR_BAO']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MGR_FULI']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['MGR_FEE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <!-- <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_FUND']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['RD_DEVFEE']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> -->
                            <div style="text-align:center;min-width:20px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc"> </div>
                            <!-- 财务费用 -->
                            <div style="text-align:center;min-width:85px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_EMP']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div> 
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_BAO']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_FULI']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_INTEREST']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_COMM']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_TAX']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:70px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="v_row['FIN_EXCHG']" @input="calcAmt" style="width:100%" size="small"> </el-input> 
                            </div>
                            <div style="text-align:center;min-width:35px;line-height:45px;border-right:1px solid #ccc;height:45px;border-bottom:1px solid #ccc">
                                
                            </div>
                        </div>
                        <div style="display:flex;line-height:35px;font-size:14px;font-weight:700;margin-top:5px;color:#ff0000">
                            成本计算公式：BOM成本 * {{v_row['NET']}} * {{v_row['ACTCOST']}}
                        </div>
                    </div>
                </div>
                <!-- <div v-for="(item,index) in lineArr" :key="index" style="line-height:35px;height:35px;min-width:800px; display:flex;font-size:12px;font-weight:bold">
                    <el-select v-model="item['SYMBOL']"  @change="selectChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in symArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-select v-model="item['FLDNO']" @change="selectChg" placeholder="请选择" clearable size="small" style="width:150px; ">
                        <span v-for="(item,index) in fldArr" :key='index'>
                            <el-option :label="item.CNAME" :value="item.CNAME"></el-option>
                        </span>
                    </el-select> 
                    <el-select v-model="item['OPER']" @change="selectChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in calcArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-input type="number" @input="selectChg" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="item['TXTVAL']" style="width:150px" size="small"> </el-input> 
                    <el-select v-model="item['OPER2']"  @change="selectChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in calcArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-button :disabled="treeid==0" @click="lineAdd" type="primary" size="mini" icon="iconfont icon-xinzeng" style="width:45px;margin-left:10px;height:32px"></el-button>
                    <el-button :disabled="treeid==0" @click="lineDel(index)" v-if="index>0" type="danger" size="mini" icon="iconfont icon-shanchu" style="width:45px;margin-left:10px;height:32px"></el-button>
                </div>
                <div style="height:32px">
                    <el-input v-model="v_calcVal" size="small" placeholder="公式设定方法描述" readonly=""></el-input>
                </div> -->
                <!-- <div class="one-div"> 
                    <div class="oneRow">
                        <span style="font-size:12px;margin-right:15px;">基准出口售价【美元】公式设置</span> 
                        <el-button :disabled="treeid==0" @click="calcSave2" type="plain" size="mini" icon="el-icon-s-tools"> 保存公式</el-button>
                        <el-button :disabled="treeid==0" @click="delSave2" type="danger" size="mini" icon="el-icon-close"> 删除公式</el-button>
                    </div>
                </div> -->
                <!-- <div style="line-height:35px;height:35px;min-width:700px; display:flex;font-size:12px;font-weight:bold;color:#389">
                    <div style="text-align:center;width:120px">括号符 </div>
                    <div style="text-align:center;width:150px">字段类型 </div>
                    <div style="text-align:center;width:120px">操作符 </div>
                    <div style="text-align:center;width:150px">值 </div>
                    <div style="text-align:center;width:120px">操作符2 </div>
                </div> -->
                <!-- <div v-for="(item,index) in usArr" :key="index+`-`" style="line-height:35px;height:35px;min-width:800px; display:flex;font-size:12px;font-weight:bold">
                    <el-select v-model="item['SYMBOL']"  @change="usChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in symArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-select v-model="item['FLDNO']" @change="usChg" placeholder="请选择" clearable size="small" style="width:150px; ">
                        <span v-for="(item,index) in fldArr" :key='index'>
                            <el-option :label="item.CNAME" :value="item.CNAME"></el-option>
                        </span>
                    </el-select> 
                    <el-select v-model="item['OPER']" @change="usChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in calcArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-input type="number" @input="usChg" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-model="item['TXTVAL']" style="width:150px" size="small"> </el-input> 
                    <el-select v-model="item['OPER2']"  @change="usChg"  placeholder="请选择" clearable size="small" style="width:120px; ">
                        <span v-for="(item,index) in calcArr" :key='index'>
                            <el-option :label="item" :value="item"></el-option>
                        </span>
                    </el-select> 
                    <el-button :disabled="treeid==0" @click="lineAdd2" type="primary" size="mini" icon="iconfont icon-xinzeng" style="width:45px;margin-left:10px;height:32px"></el-button>
                    <el-button :disabled="treeid==0" @click="lineDel2(index)" v-if="index>0" type="danger" size="mini" icon="iconfont icon-shanchu" style="width:45px;margin-left:10px;height:32px"></el-button>
                </div>
                <div style="height:32px;margin-bottom:10px">
                    <el-input v-model="v_calcVal2" size="small" placeholder="公式设定方法描述" readonly=""></el-input>
                </div> -->
                <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addModal" width="1050px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">属性：{{type==='create'?'新增':type==='edit'?'编辑':'查看'}}</span>
                    </div> 
                    <Form :model="propRow" :label-width="120" ref="addForm" label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in tabCol" :key="index" >
                            <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                                <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="propRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input   v-enter-number  v-else-if="item.edcss==='number'" v-model="propRow[item.key]" style="width:100%" ></el-input>   
                                <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="propRow[item.key]" style="width:100%"></el-checkbox> 
                                <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="propRow[item.key]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:25px;">取消</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="modal_ok" style="margin-right:10px;">保存</el-button>
                        </span>
                    </div>  
                </el-dialog> 
                <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="dtlModal" width="1050px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">规格：{{dtlFlag==='create'?'新增':type==='edit'?'编辑':'查看'}}</span>
                    </div> 
                    <Form :model="dtlRow" :label-width="120" ref="addForm" label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in dtlCol" :key="index" >
                            <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                                <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input   v-enter-number  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]" style="width:100%" ></el-input>   
                                <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlRow[item.key]" style="width:100%"></el-checkbox> 
                                <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                    <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                        <span style="float:right">
                            <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlModal=false" style="margin-right:25px;">取消</el-button>
                            <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="dtl_ok" style="margin-right:10px;">保存</el-button>
                        </span>
                    </div>  
                </el-dialog> 
            </div>
            <el-dialog v-dialogDrag :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div> 
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog v-dialogDrag :visible.sync="typeWin" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">产品类别设置</span>
                </div>
                <prodType @child-close="freshTree"></prodType>
            </el-dialog>
        </template>
    </split-pane>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import prodType from '../datamgt/prdtype.vue' 
export default {
    name: 'prd_attrib',
    data () {
        return {
            addModal:false, //modal 
            typeWin:false,
           
            oper:'like',
            v_row:{}, // 
            prompt:'', // 
            dtlModal:false,
            dtlName:'',
            dtlRow:{},
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            tmpData:[] ,// 
            filterText: '',
            v_calcVal:'',
            v_calcVal2:'',
            lvl:'1',
            operArr:[],
            dtlFlag:'create',
            baseData:[] ,//表数据
            propRow:{} ,//  
            orgData:[] ,//组织部门 
            dtlData:[],
            dtlCol:[],
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
   
            v_url:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            ruleValidate: {},
            dtlIdseq:'',
            dtlLstseq:'',
            fldArr:[], // 
            lineArr:[{SYMBOL:'',FLDNO:'',OPER:'',TXTVAL:'',OPER2:'',LSTSEQ:'',IDTY:'RMB'}], 
            usArr:[{SYMBOL:'',FLDNO:'',OPER:'',TXTVAL:'',OPER2:'',LSTSEQ:'',IDTY:'US'}], 
            symArr:['(','((','(((','((((',')','))',')))','))))'],
            calcArr:['+','-','*','/'],
            notNull:[],
            treeid:'0',
            nodeLabel:'',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        this.getFormData( '-1','') //初始查询表数据   
        this.getData() //表单 分组 数据  
    },
    components: {
        prodType,
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })  
        getBaseData('xuper_auth/getBaseData','PARENTNO','438749','','','v_sys_base','').then(res=>{
            this.fldArr =res.result
        })  
        
        this.$refs.refqry.focus()
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','lstseq','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4271','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
               // console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    } ,
    computed: {
        tabHeight() { 
          return  window.innerHeight -470
        },
        scrollerHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    watch: {
      filterText(val) {
        this.$refs.eltree.filter(val);
      }
    },
    methods: {  
        calcAmt(){
            this.v_row['ACTCOST'] =''
            this.v_row['NET'] =''
 
            // 1、制造费用--人工
            let v_make1 =0
            if (this.v_row['MAKE_EMP']){
                v_make1 =this.v_row['MAKE_EMP']
            }
            //2、 制造费用--社保
            let v_make2 =0
            if (this.v_row['MAKE_BAO']){
                v_make2 =this.v_row['MAKE_BAO']
            }
            // 3、制造费用--福利
            let v_make3 =0
            if (this.v_row['MAKE_FULI']){
                v_make3 =this.v_row['MAKE_FULI']
            }
            // 4、制造费用--水电摊分
            let v_make4 =0
            if (this.v_row['MAKE_WATER']){
                v_make4 =this.v_row['MAKE_WATER']
            }
            // 5、制造费用--租金摊分
            let v_make5 =0
            if (this.v_row['MAKE_RENT']){
                v_make5 =this.v_row['MAKE_RENT']
            }
            // 6、制造费用--损耗率
            let v_make6 =0
            if (this.v_row['MAKE_WASTE']){
                v_make6 =this.v_row['MAKE_WASTE']
            }

            // 1、销售费用--人工
            let v_sale1 =0
            if (this.v_row['SALE_EMP']){
                v_sale1 =this.v_row['SALE_EMP']
            }
            //2、 销售费用--社保
            let v_sale2 =0
            if (this.v_row['SALE_BAO']){
                v_sale2 =this.v_row['SALE_BAO']
            }
            // 3、销售费用--福利
            let v_sale3 =0
            if (this.v_row['SALE_FULI']){
                v_sale3 =this.v_row['SALE_FULI']
            }
            // 4、销售费用--办公费用
            let v_sale4 =0
            if (this.v_row['SALE_FEE']){
                v_sale4 =this.v_row['SALE_FEE']
            }
            // 5、销售费用--运输费
            let v_sale5 =0
            if (this.v_row['SALE_SHIP']){
                v_sale5 =this.v_row['SALE_SHIP']
            }
            // 6、销售费用--提成
            let v_sale6 =0
            if (this.v_row['SALE_FUND']){
                v_sale6 =this.v_row['SALE_FUND']
            }
            // 7、销售费用--广告
            let v_sale7 =0
            if (this.v_row['SALE_ADVER']){
                v_sale7 =this.v_row['SALE_ADVER']
            }
             // 1、研发费用--人工
            let v_rd1 =0
            if (this.v_row['RD_EMP']){
                v_rd1 =this.v_row['RD_EMP']
            }
            //2、 研发费用--社保
            let v_rd2 =0
            if (this.v_row['RD_BAO']){
                v_rd2 =this.v_row['RD_BAO']
            }
            // 3、研发费用--福利
            let v_rd3 =0
            if (this.v_row['RD_FULI']){
                v_rd3 =this.v_row['RD_FULI']
            }
            // 4、研发费用--办公费
            let v_rd4 =0
            if (this.v_row['RD_OFFICE']){
                v_rd4 =this.v_row['RD_OFFICE']
            }
            // 5、研发费用--提成
            let v_rd5 =0
            if (this.v_row['RD_FUND']){
                v_rd5 =this.v_row['RD_FUND']
            }
            // 6、研发费用--开发费
            let v_rd6 =0
            if (this.v_row['RD_DEVFEE']){
                v_rd6 =this.v_row['RD_DEVFEE']
            }

            // 1、财务费用--人工
            let v_fin1 =0
            if (this.v_row['FIN_EMP']){
                v_fin1 =this.v_row['FIN_EMP']
            }
            //2、 财务费用--社保
            let v_fin2 =0
            if (this.v_row['FIN_BAO']){
                v_fin2 =this.v_row['FIN_BAO']
            }
            // 3、财务费用--福利
            let v_fin3 =0
            if (this.v_row['FIN_FULI']){
                v_fin3 =this.v_row['FIN_FULI']
            }
            // 4、财务费用--利息
            let v_fin4 =0
            if (this.v_row['FIN_INTEREST']){
                v_fin4 =this.v_row['FIN_INTEREST']
            }
            // 5、财务费用--手续费
            let v_fin5 =0
            if (this.v_row['FIN_COMM']){
                v_fin5 =this.v_row['FIN_COMM']
            }
            // 6、财务费用--税费
            let v_fin6 =0
            if (this.v_row['FIN_TAX']){
                v_fin6 =this.v_row['FIN_TAX']
            }
            // 7、财务费用--汇兑
            let v_fin7 =0
            if (this.v_row['FIN_EXCHG']){
                v_fin7 =this.v_row['FIN_EXCHG']
            }

             // 1、管理费用--人工
            let v_mgr1 =0
            if (this.v_row['MGR_EMP']){
                v_mgr1 =this.v_row['MGR_EMP']
            }
            //2、 管理费用--社保
            let v_mgr2 =0
            if (this.v_row['MGR_BAO']){
                v_mgr2 =this.v_row['MGR_BAO']
            }
            // 3、管理费用--福利
            let v_mgr3 =0
            if (this.v_row['MGR_FULI']){
                v_mgr3 =this.v_row['MGR_FULI']
            }
            // 4、管理费用
            let v_mgr4 =0
            if (this.v_row['MGR_FEE']){
                v_mgr4 =this.v_row['MGR_FEE']
            }
            let v_cost =  (100 + Number(v_make1)+ Number(v_make2)+ Number(v_make3)+ Number(v_make4)+ Number(v_make5)+ Number(v_make6)
                        + Number(v_sale1)+ Number(v_sale2)+ Number(v_sale3)+ Number(v_sale4)+ Number(v_sale5)+ Number(v_sale6)+ Number(v_sale7)
                        + Number(v_rd1)+ Number(v_rd2)+ Number(v_rd3)+ Number(v_rd4)+ Number(v_rd5)+ Number(v_rd6) 
                        + Number(v_mgr1)+ Number(v_mgr2)+ Number(v_mgr3)+ Number(v_mgr4) 
                        + Number(v_fin1)+ Number(v_fin2)+ Number(v_fin3)+ Number(v_fin4)+ Number(v_fin5)+ Number(v_fin6)+ Number(v_fin7)
                        ) / 100
            this.v_row['ACTCOST']  =v_cost.toFixed(4)
            if (this.v_row['NET_PCT']){
                this.v_row['NET'] =((100+Number(this.v_row['NET_PCT']))/100).toFixed(2)
            }else{
                this.v_row['NET'] =1
            }
        },
        selectChg(){
            this.v_calcVal =''
            this.lineArr.forEach(item =>{
                let oper2_ =''
                if (item['OPER2']){
                    oper2_= item['OPER2']
                }
                let oper_ =''
                if (item['OPER']){
                    oper_= item['OPER']
                }
                let txtval2_ =''
                if (item['TXTVAL']){
                    txtval2_= item['TXTVAL']
                }
                let fldno_ =''
                if (item['FLDNO']){
                    fldno_= item['FLDNO']
                }
                let symbol_ =''
                if (item['SYMBOL']){
                    symbol_= item['SYMBOL']
                }
                let v_val =symbol_ +fldno_+oper_ +txtval2_ +oper2_
                if (this.v_calcVal ){
                    this.v_calcVal =this.v_calcVal +v_val
                }else{
                    this.v_calcVal =v_val
                }
            })
        },
        // 公式设置
        getCalcList(){     
            this.v_row={}
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'code', p_value:this.treeid ,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_bs_type'},
            }).then(res=>{ 
                this.v_row =res.result[0] 
            }) 
        },
  
        //保存公式
        calcSave(){
            if (this.v_row['ACTCOST']){
                //先查询记录
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'code', p_value:this.treeid ,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_bs_type'},
                }).then(res=>{ 
                    let v_obj =res.result[0]
                    // 先更新值
                    this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
                        method: 'post',
                        url: 'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(v_obj,this.v_row)), p_table:'bs_type',frmid:''},
                    }).then(res=>{                   
                       // this.getCalcList()
                        this.$message.success('已成功保存！')     
                    })
                })
            }else{
                this.promptWin =true
                this.prompt ='设置公式不能为空'
            }
 
        },
 
        lineAdd(){
            this.lineArr.push({SYMBOL:'',FLDNO:'',OPER:'',TXTVAL:'',OPER2:'',LSTSEQ:'',IDTY:'RMB'})
        },
        lineDel(index){
            this.lineArr.splice(index,1)
            this.selectChg()
        },
  
        //类别维护
        freshTree(){
            this.getData()
        },
        typeSet(){
            this.typeWin =true
        },
        dtlAdd(){
          if (!this.dtlIdseq){
            this.promptWin=true
            this.prompt='属性名称为空时不能新增'
          }else{
            this.dtlModal=true
            this.dtlRow={PCNAME:this.dtlName}
            this.dtlFlag='create'
          }
        },
        getRowKey(row){
          return row.LSTSEQ
        },
        getRowKey2(row){
          return row.ITMSEQ
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.lvl=data.icon
            console.log(data.id,'..')
            if (data.id==='0'){
                this.getFormData( '-1','')
            }else{
                this.getFormData( data.id,'')
            }
            this.getCalcList()
 
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.loading =true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'v_BS_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\' and ty=\'PRD\'' }
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.orgData =res.result
                    vm.loading =false 
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }  
                         
            })                            
        },
        //规格保存 
        dtl_ok(){  
            if(this.dtlRow['CNAME']){ 
                  this.$axios({
                      method: 'post',
                      url:'xuper_auth/tableBodySave2',
                      data: {p_json:JSON.stringify(Object.assign(this.dtlRow,{CORPID:this.v_corpid,IDSEQ:this.dtlIdseq,LSTSEQ:this.dtlLstseq})), p_table:'prd_propdtl'},
                  }).then(res=>{      
                      if(res.code ==='200')  {          
                          this.dtlModal =false   
                          this.getDtlData(this.dtlIdseq,this.dtlLstseq)
                      }else{
                          if (res.result.indexOf('ORA-00001')>-1){
                                this.promptWin=true
                                this.prompt='重复的属性规格值，请核查'
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }
                      }        
                  }) 
            }else{
                this.promptWin=true
                this.prompt='属性规格值不能为空'
            }
        }, 
        //表单确定按钮 两个特殊数据类型： null ,undefined 当为null时 用 ! ,为undefined 用 typeof
        modal_ok(){
            //var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            var vm =this
            let ctryno_=''
            //发起保存请求   
            this.$refs['addForm'].validate((valid) => {
                if (valid)  {     
                    vm.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(vm.propRow,{CORPID:this.v_corpid })), p_table:'prd_prop',p_idseq:this.treeid},
                    }).then(res=>{      
                        if(res.code ==='200')  {          
                            vm.addModal =false   
                            vm.qryTabData()
                        }else{
                            if (res.result.indexOf('ORA-00001')>-1){
                                this.promptWin=true
                                this.prompt='重复的属性名称，请核查'
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }
                        }        
                    }) 
                }
            })
        },
        //删除记录
        delRec(row,index){
          this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
               this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'prd_prop'},
                }).then(res=>{      
                    if(res.code =='200')  {      
                        this.tmpData.splice(index,1 )      
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }).catch(()=>{})
        },
        dtlDel(row,index){
          this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
               this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_key3:'itmseq',p_value3:row.ITMSEQ,p_table:'prd_propdtl'},
                }).then(res=>{      
                    if(res.code =='200')  {      
                        this.dtlData.splice(index,1 )      
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }).catch(()=>{})
        },
        //新增记录
        addRec(){
          if (this.lvl=='1'||this.lvl=='0'){
            this.promptWin=true
            this.prompt='该节点下不能新增,请选择子节点新增'
          }else{
            this.addModal =true
            this.type ='create'
            this.propRow ={PCODE:this.treeid,PCNAME:this.nodeLabel,ISHAND:'N'}
          }
        },
        //修改记录
        editRec(row,val){
           this.propRow=JSON.parse(JSON.stringify(row)) 
           this.addModal =true         
           this.type='edit'
        },
        dtlEdit(row ){
           this.dtlRow=JSON.parse(JSON.stringify(row)) 
           this.dtlModal =true         
           this.dtlFlag='edit'
        },
        //查询选择器事件
        elchange(value){
            let obj ={}
            obj =this.tabCol.find(item=>{
                return item.key===value
            })
            this.input_hold='请输入'+obj.title+' 的值'
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.textparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.textparam+'\''
                }
            }
            this.getFormData( this.treeid,cond_ )
        },
 
        //获取表单数据
        getFormData( subno,cond){
            getTabColOrData(this.v_url,'V_PRD_PROP','IDSEQ',subno,'','',cond).then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result
                    if(res.result.length>0){
                      this.dtlIdseq=res.result[0].IDSEQ
                      this.dtlLstseq=res.result[0].LSTSEQ
                      this.dtlName=res.result[0].CNAME
                      this.$refs.proptab.setCurrentRow(this.tmpData[0])
                      //明细查询第一行属性
                      this.getDtlData(res.result[0].IDSEQ,res.result[0].LSTSEQ)
                    }else{
                      this.dtlData=[]
                      this.dtlIdseq=''
                      this.dtlLstseq=''
                    }   
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.proptab.doLayout();
                    }) 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }    
            });            
        },
        //明细数据
        getDtlData( idseq,lstseq){
            getTabColOrData(this.v_url,'V_PRD_PROPDTL','IDSEQ',idseq,'lstseq',lstseq,'').then((res) => {              
                if (res.code==='200'){
                    this.dtlData=res.result    
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.dtltab.doLayout();
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }    
            });            
        },
        dtlClick(row){
          this.getDtlData(row.IDSEQ,row.LSTSEQ)
          this.dtlIdseq=row.IDSEQ
          this.dtlLstseq=row.LSTSEQ
          this.dtlName=row.CNAME
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            });
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4271','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
